import React, {CSSProperties} from 'react';
import {CollectionLayout} from '../Product/LayoutSelector';
import ThemedLayout from './ThemedLayout';

type ThemedLayoutsListProps = {
  layouts: CollectionLayout[];
  columns: number;
  columnGap?: number;
  onClick: (layout: CollectionLayout) => void;
};

const ThemedLayoutsList = ({layouts, columns, columnGap, onClick}: ThemedLayoutsListProps) => {
  // Tailwind classes for the UL
  const thumbnailListClasses = [
    'flex',
    'w-[calc(100%+var(--gap))]',
    'self-start',
    'items-start',
    'flex-wrap',
    '-mt-[var(--gap)]',
    '-ml-[var(--gap)]',
  ];

  const cssProperties = {'--columns': columns, '--gap': columnGap + 'rem'};

  return (
    <ul className={thumbnailListClasses.join(' ')} style={cssProperties as CSSProperties}>
      {layouts &&
        layouts.map((layout: CollectionLayout, index: number) => {
          return (
            <ThemedLayout
              layout={layout}
              onClick={onClick}
              key={layout.collection.collectionUniqueRef}
            />
          );
        })}
    </ul>
  );
};

export default ThemedLayoutsList;
